module.exports = __webpack_public_path__ + "static/media/signup-background.bcd4da72.svg";